// The invite to rest longer after a set at or near failure. An OFFER, never a
// rewrite: the timer keeps the rest the athlete or the coach chose, and this
// only says how much more the studies would suggest.
//
// Sources for the two targets:
// - Janićijević et al. 2024, J Sports Sci, doi 10.1080/02640414.2024.2317644:
//   5 min between sets close to failure at 75% 1RM.
// - Senna et al. 2017, J Hum Kinet: 3-5 min between sets to failure at 80% 1RM.

/** A set at or under this RIR counts as close to failure. */
const NEAR_FAILURE_MAX_RIR = 0;
/** Heavy-set boundary: up to this many reps takes the long target. */
const REST_INVITE_HEAVY_MAX_REPS = 10;
/** Target rest after a heavy set (≤ 10 reps) near failure. */
const REST_INVITE_HEAVY_SEC = 300;
/** Target rest after a lighter set (> 10 reps) near failure. */
const REST_INVITE_LIGHT_SEC = 180;

function isNearFailure({
  rir,
  fail,
}: {
  rir: number | null;
  fail: boolean;
}): boolean {
  return fail || (rir !== null && rir <= NEAR_FAILURE_MAX_RIR);
}

/** Seconds to offer on top of the rest already armed; 0 means no invite.
 *  No reps means no target to read, so no invite either. */
export function restInviteSeconds({
  reps,
  rir,
  fail,
  resolvedSec,
}: {
  reps: number | null;
  rir: number | null;
  fail: boolean;
  /** What resolveRestSeconds gave this set, coach prescription included. */
  resolvedSec: number;
}): number {
  if (!isNearFailure({ rir, fail })) return 0;
  if (reps === null || !Number.isFinite(reps) || reps <= 0) return 0;
  const target =
    reps <= REST_INVITE_HEAVY_MAX_REPS
      ? REST_INVITE_HEAVY_SEC
      : REST_INVITE_LIGHT_SEC;
  return Math.max(0, target - resolvedSec);
}
